var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.777 16.3431C13.777 17.5144 12.9239 18.464 11.5214 18.464C10.2021 18.4621 9.349 17.5144 9.349 16.3431C9.349 15.1424 10.2292 14.2222 11.5775 14.2222C12.9239 14.2222 13.7499 15.1424 13.777 16.3431ZM9.45925 33.7777V20.1358H13.6396V33.7777H9.45925Z",
    fill: "#ED1C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8875 24.4875C15.8875 22.7864 15.8332 21.3639 15.7772 20.1357H19.4082L19.6016 22.033H19.6847C20.2341 21.1403 21.5824 19.8296 23.838 19.8296C26.5888 19.8296 28.651 21.6994 28.651 25.7157V33.7777H24.4706V26.218C24.4706 24.46 23.8651 23.2612 22.3524 23.2612C21.1975 23.2612 20.5107 24.0696 20.207 24.8505C20.0968 25.1291 20.0697 25.5195 20.0697 25.91V33.7777H15.8875V24.4875Z",
    fill: "#ED1C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/Linkdin.fa2c801a0064d2e7fcb39e2ae3ee3b55.svg";
export { ForwardRef as ReactComponent };